import {ILoadingState} from 'plugins/loading/types';
import {PayloadAction} from '@reduxjs/toolkit';

export const createLoadingActions = <X extends ILoadingState>() => {
    function actionSetIsLoading(state: X, {payload}: PayloadAction<X['isLoading']>) {
        state.isLoading = payload;
    }

    function actionSetAtomLoading(state: X, {payload}: PayloadAction<NonNullable<X['atom']>>) {
        if (!Object.keys(payload).length) {
            return;
        }
        const [[key, value]] = Object.entries(payload);

        if (!state.atom) {
            state.atom = {
                [key]: value,
            };
        } else {
            state.atom[key] = value;
        }
    }

    return {actionSetAtomLoading, actionSetIsLoading};
};
